import React from 'react';
import CardTable from '../CardTable';
import { formatDate, formatRate } from '../format';
import styles from '../card.module.css';

/* Вкладка «Штат» (п. 7 ТЗ). Только просмотр: ни кнопки «Изменить», ни экрана
   редактирования штатной позиции в режиме нет.

   Строки идут в порядке сервера, включая записи замещения (main_fpid <> 0):
   отдельным видом строки они в требованиях к вкладке не описаны. */

const COLUMNS = [
  { key: 'code', title: 'Код', cell: row => row.code, className: styles.mono },
  { key: 'position', title: 'Должность', cell: row => row.position, className: styles.lead },
  { key: 'indicator', title: <>Признак<br />должности</>, cell: row => row.position_indicator },
  { key: 'tariff', title: 'Разряд', cell: row => row.tariff, className: styles.mono },
  { key: 'level', title: 'Уровень', cell: row => row.level },
  { key: 'rank', title: 'Звание', cell: row => row.rank },
  { key: 'vus', title: 'ВУС', cell: row => row.vus },
  { key: 'employment', title: <>Вид<br />занятости</>, cell: row => row.employment_type },
  { key: 'rate', title: 'Ставка', cell: row => formatRate(row.rate), className: styles.mono },
  { key: 'employee', title: 'Сотрудник', cell: row => (row.is_vacant ? 'Нет' : row.employee) },
  { key: 'date', title: 'Дата', cell: row => formatDate(row.assign_date), className: styles.mono },
  { key: 'deputy', title: 'Замещение', cell: row => row.deputy },
  {
    key: 'track',
    title: <>Отслеживать<br />ППК</>,
    cell: row => (row.track_qualify_update ? 'Да' : 'Нет'),
  },
];

const Personnel = ({ data }) => (
  <CardTable
    columns={COLUMNS}
    rows={data.items}
    rowKey={row => row.fpid}
    counter={<>Всего записей: <b>{data.count}</b> - вакантных: <b>{data.vacancy_count}</b></>}
    emptyTitle="Штатных позиций нет"
    emptyText="За факультетом не заведено ни одной штатной единицы"
  />
);

export default Personnel;
